import React, { useState, useEffect } from "react";

import "../AdminLogin/AdminLogin.scss";
import Auth_Logo from "../../../assets/images/logo/logo.svg";
import Eye from "../../../assets/images/vactor/eye.svg";
import EyeLine from "../../../assets/images/vactor/eye-line.svg";
import Right_Arrow from "../../../assets/images/vactor/arrow-right.svg";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { PrimaryButton } from "../../../components/AllButtons/AllButtons";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../Store/store";
import { loginUser } from "../../../Services/auth.service";
import { openSnackbar } from "../../../Slice/snackbarSlice";
import { login } from "../../../Slice/userSlice";
import Loader from "../../../components/Loader/Loader/Loader";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const validateEmail = (email: any) => {
    // Strong email regex pattern
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleEmailChange = (e: any) => {
    const value = e.target.value;
    setEmail(value);
    if (value === "") {
      setEmailError("");
    } else if (!validateEmail(value)) {
      setEmailError("Invalid email");
    } else {
      setEmailError("");
    }
  };

  const handlePasswordChange = (e: any) => {
    setPassword(e.target.value);
  };

  const handleSignUp = async () => {
    const token = localStorage.getItem("auth-token");
    const role = localStorage.getItem("role");
    if (token) {
      if (role === "admin") {
        navigate("/admin");
      } else {
        navigate("/dashboard");
      }
      return;
    }
    setLoading(true);  // show loading before request

    const requestBody = {
      username: email,
      password: password,
    };

    try {
      const response = await dispatch(loginUser(requestBody)).unwrap();

      if (response.status) {
        dispatch(openSnackbar({ message: response.message + " 🎉", severity: "success" }));
        dispatch(login(response));
        setLoading(false);  // hide loading before navigating
        navigate("/admin");
      } else {
        dispatch(openSnackbar({ message: response.message || "Invalid Credentials ❌", severity: "error" }));
        setLoading(false);
      }
    } catch (error) {
      dispatch(openSnackbar({ message: "Login failed ❌", severity: "error" }));
      setLoading(false);
      navigate("/login");
    }
  };

  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === 'auth-token' && e.newValue) {
        const role = localStorage.getItem("role");
        if (role === "admin") {
          navigate("/admin");
        } else {
          navigate("/dashboard");
        }
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [navigate]);

  const isFormValid = validateEmail(email) && password.length > 0;
  if (loading) {
    return <Loader />
  }
  return (
    <>
      <div className="admin-auth-wrapper">
        <div className="admin-auth-form">
          <div className="admin-auth-form-header">
            <div className="auth-logo">
              <img src={Auth_Logo} alt="Logo" />
            </div>
            <p className="content-dsc-text">Welcome Back!</p>
          </div>
          <div className="input-form-field-wrapper w-100">
            <TextField
              className="out-label-input-text"
              id="username"
              name="username"
              placeholder="Email address"
              margin="normal"
              variant="outlined"
              fullWidth
              type="email"
              value={email}
              onChange={handleEmailChange}
              error={!!emailError}
            />
            {emailError && (
              <div style={{ color: "red", fontSize: "0.75rem", marginTop: "2px" }}>
                {emailError}
              </div>
            )}
          </div>

          <div className="input-form-field-wrapper w-100">
            <TextField
              className="out-label-input-text"
              name="password"
              placeholder="Password"
              margin="normal"
              variant="outlined"
              fullWidth
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={handlePasswordChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      edge="end"
                      onClick={() => setShowPassword(!showPassword)}
                      disabled={password.length === 0}
                    >
                      <img src={showPassword ? Eye : EyeLine} alt="Toggle password" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          {/* <div className="forgot-link" style={{ marginTop: "1px" }}>
            <Link to="">Forgot password?</Link>
          </div> */}

          <div className="auth-action-control">
            <PrimaryButton
              onClick={handleSignUp}
              disabled={!isFormValid}
              style={{
                cursor: isFormValid ? "pointer" : "not-allowed",
                color: "#fff"
              }}
            >
              Sign in
              <img src={Right_Arrow} alt="Right_Arrow" />
            </PrimaryButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;